import { ImageFormat, type ImageMetadata, type UrlWrappedAssetPath } from '@/types'
import TmLogicError from '@/core/error/tmLogicError'

const imageFormatPriority = [ImageFormat.AVIF, ImageFormat.WEBP, ImageFormat.PNG, ImageFormat.JPEG]

const getPixelDensityMultiplier = (pixelDensityDescriptor: string) => {
  const multiplier = pixelDensityDescriptor.slice(0, -1)
  return Number(multiplier)
}

export const getImageSetFromMetadata = (metadata: ImageMetadata[]) => {
  if (metadata.length === 0) {
    throw new TmLogicError('No images provided')
  }

  const srcset = metadata.sort(
    (a, b) =>
      imageFormatPriority.indexOf(a.format) - imageFormatPriority.indexOf(b.format) ||
      (b.pixelDensityDescriptor ? getPixelDensityMultiplier(b.pixelDensityDescriptor) : 0) -
        (a.pixelDensityDescriptor ? getPixelDensityMultiplier(a.pixelDensityDescriptor) : 0),
  )

  return {
    imageSet: `image-set(${srcset
      .map((i) => `url('${i.src}') type('image/${i.format}') ${i.pixelDensityDescriptor ?? '1x'}`)
      .join(', ')})`,
    fallback: `url(${srcset[srcset.length - 1].src})` satisfies UrlWrappedAssetPath,
  }
}
